import {FIELD_TYPE} from "types/enums";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Tên API",
    name: "name",
  },
];
const columns: any[] = [
  {
    title: "Mã",
    dataIndex: "id",
    key: "id",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Method",
    dataIndex: "httpMethod",
    key: "httpMethod",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "API",
    dataIndex: "name",
    key: "name",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    key: "description",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Scheme",
    dataIndex: "scheme",
    key: "scheme",
    show: true,
    isResizable: true,
    align: "left",
  },

  // {
  //   title: "Thao tác",
  //   dataIndex: "action",
  //   key: "action",
  //   show: true,
  //   isResizable: true,
  //   align: "center",
  // },
];

export {fields, columns};
